import React, { useEffect, useState } from "react";
import {
  Box,
  Modal,
  Typography,
  TextField,
  Button,
  Stack,
} from "@mui/material";
import EditCreditNoteModalStyles from "./EditCreditNoteModalStyles";

export interface CreditNoteFormData {
  preTaxTotal?: number;
  invoice?: string;
  date?: string;
}

interface EditCreditNoteModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: (data: CreditNoteFormData) => void;
  initialFormData?: CreditNoteFormData;
}

const EditCreditNoteModal: React.FC<EditCreditNoteModalProps> = ({
  open,
  onClose,
  onConfirm,
  initialFormData = { preTaxTotal: undefined, invoice: "" },
}) => {
  const [formData, setFormData] = useState<CreditNoteFormData>(initialFormData);

  useEffect(() => {
    setFormData(initialFormData || { preTaxTotal: undefined, invoice: "" });
  }, [initialFormData]);

  const handleAmountChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setFormData((prev) => ({
        ...prev,
        preTaxTotal: value === "" ? undefined : Number(value),
      }));
    }
  };

  const handleConfirm = () => {
    onConfirm(formData);
    onClose();
  };

  return (
    <Modal open={open} onClose={onClose} disableScrollLock={false}>
      <Box sx={EditCreditNoteModalStyles.modalBox}>
        <Typography variant="h6" sx={EditCreditNoteModalStyles.title}>
          Edit Credit Note
        </Typography>

        <Typography variant="body2" sx={EditCreditNoteModalStyles.label}>
          Pre-Tax Total
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          value={formData.preTaxTotal ?? ""}
          onChange={handleAmountChange}
          type="text"
          inputProps={{ inputMode: "numeric", pattern: "[0-9]*" }}
        />

        <Typography variant="body2" sx={EditCreditNoteModalStyles.label}>
          Towards Invoice No.
        </Typography>
        <TextField
          fullWidth
          variant="outlined"
          value={formData.invoice || ""}
          disabled
        />

        <Stack
          direction="row"
          spacing={2}
          justifyContent="flex-end"
          sx={EditCreditNoteModalStyles.actions}
        >
          <Button
            variant="contained"
            sx={EditCreditNoteModalStyles.confirmButtonStyle}
            onClick={handleConfirm}
          >
            Confirm
          </Button>
          <Button
            variant="outlined"
            sx={EditCreditNoteModalStyles.cancelButtonStyle}
            onClick={onClose}
          >
            Cancel
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};

export default EditCreditNoteModal;
